import AnalyticsLogger from './service/analytics';
import Storage from './service/storage';

const analyticsLogger = new AnalyticsLogger();
const storage = new Storage();

export { analyticsLogger, storage };
